import { includes } from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";

const useGetPageByRole = () => {
  const showPromoPage = useSelector((state) => state.base.showPromoPage);
  const user = useSelector((state) => state.user);

  const pageByRole = useMemo(() => {
    const roles = user?.roles || [];

    const USER_SETTINGS = "/user/settings";

    if (includes(roles, "admin")) {
      return "/user/admin/users";
    } else if (includes(roles, "partner")) {
      return showPromoPage ? "/user/partner/promo" : USER_SETTINGS;
    } else if (includes(roles, "referrer")) {
      return showPromoPage ? "/user/referrer/promo" : USER_SETTINGS;
    } else if (includes(roles, "affiliate")) {
      return showPromoPage ? "/user/affiliate/promo" : USER_SETTINGS;
    }

    return "/user/settings";
  }, [user, showPromoPage]);

  return pageByRole;
};

export default useGetPageByRole;
